import { useState, useEffect } from 'react';
import { useChatContext } from 'stream-chat-react';
import { StreamEventType } from '@features/components/Chat/constants';

/**
 * Unlike `useChannelPreviewState` (which relies on the ChannelList SDK re-render
 * cycle), this hook self-subscribes to the relevant Stream events to reactively update
 * the pinned and muted state of the active channel
 */
export const useActiveChannelState = () => {
  const { client, channel } = useChatContext();

  const [isPinned, setIsPinned] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    if (!channel) return;

    const syncState = () => {
      setIsPinned(!!channel.state?.membership?.pinned_at);
      setIsMuted(!!client.mutedChannels?.some((m) => m.channel?.id === channel.id));
    };

    syncState();

    client.on(StreamEventType.NOTIFICATION_CHANNEL_MUTES_UPDATED, syncState);
    channel.on(StreamEventType.CHANNEL_UPDATED, syncState);
    channel.on(StreamEventType.MEMBER_UPDATED, syncState);

    // eslint-disable-next-line consistent-return
    return () => {
      client.off(StreamEventType.NOTIFICATION_CHANNEL_MUTES_UPDATED, syncState);
      channel.off(StreamEventType.CHANNEL_UPDATED, syncState);
      channel.off(StreamEventType.MEMBER_UPDATED, syncState);
    };
  }, [channel, client]);

  return { isPinned, isMuted };
};
